import {
  Component,
  OnInit,
  signal,
  inject,
  DestroyRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  Event,
  GuardsCheckStart,
} from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '@services/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { showHideGlobalLoader } from '@utils/functions';
import { DEFAULT_CONFIG } from '@config/app.config';

@Component({
  selector: 'terpel-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly translate = inject(TranslateService);
  private readonly destroyRef = inject(DestroyRef);

  readonly loading = signal(false);

  constructor() {
    this.onTranslateLoad();
  }

  ngOnInit(): void {
    this.navigationLoader();
  }

  onActivate(): void {
    setTimeout(() => {
      showHideGlobalLoader(false);
    }, 100);
  }

  navigationLoader(): void {
    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event: Event) => {
        switch (true) {
          case event instanceof GuardsCheckStart:
          case event instanceof NavigationStart: {
            this.loading.set(true);
            break;
          }

          case event instanceof NavigationEnd:
          case event instanceof NavigationCancel:
          case event instanceof NavigationError: {
            this.loading.set(false);
            break;
          }
          default: {
            break;
          }
        }
      });
  }

  onTranslateLoad(): void {
    const delfaultLangIndex = this.authService.getDefaultLanguageIndex();
    const defaultLang = DEFAULT_CONFIG.translateLanguages[delfaultLangIndex];

    this.translate.addLangs(DEFAULT_CONFIG.translateLanguages);
    this.translate.setFallbackLang(defaultLang);
    this.translate.use(defaultLang);
  }
}
